export const buildModulePath = (moduleId: string, parentId?: string) => {
  const basePath = '/user/modules';
  return parentId ? `${basePath}/${parentId}/m/${moduleId}` : `${basePath}/${moduleId}`;
};

export const buildAgendaPath = (moduleId: string, agenda: { agendaId: string; systemType: string }, parentId?: string) => {
  const modulePath = buildModulePath(moduleId, parentId);
  return `${modulePath}/${agenda.systemType}/${agenda.agendaId}`;
};

export const buildViewPath = (moduleId: string, agenda: { agendaId: string; systemType: string }, viewId: string, parentId?: string) => {
  const agendaPath = buildAgendaPath(moduleId, agenda, parentId);
  return `${agendaPath}/view/${viewId}`;
};

export const buildHeliosUserPath = (
  routeModuleId: string,
  templateId: string,
  options?: {
    childModuleId?: string;
    recordId?: string | number;
    suffix?: string;
  }
) => {
  const childModuleId = options?.childModuleId || undefined;
  const moduleId = childModuleId || routeModuleId;
  const agendaPath = buildAgendaPath(moduleId, { agendaId: templateId, systemType: 'Helios' }, childModuleId ? routeModuleId : undefined);

  if (!options?.recordId) {
    return agendaPath;
  }

  const recordPath = `${agendaPath}/r/${options.recordId}`;
  return options.suffix ? `${recordPath}/${options.suffix}` : recordPath;
};
